import { apiGet } from '../lib/apiClient';
import type { BusinessSettings } from '../types/auth';

export function fetchBusinessSettings(): Promise<BusinessSettings> {
  return apiGet<BusinessSettings>('/business-settings');
}
